/*
 * @Author: 陈大仙人
 * @Date: 2023-03-30 15:31:41
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2024-01-10 17:15:54
 * @FilePath: /akx-pc-main/src/login/router/index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login.vue'
import Register from '../views/register.vue'
import Pass from '../views/pass.vue'
import Ad from '../views/ad.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/pass',
    name: 'Pass',
    component: Pass
  },
  {
    path: '/ad',
    name: 'Ad',
    component: Ad
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
